// Nektar Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Daniel", location: "CA", product: "Nektar® 1 Bottle", time: "18 minutes ago" },
    { name: "Shannon", location: "AL", product: "Nektar® 1 Bottle", time: "36 minutes ago" },
    { name: "Colborn", location: "UT", product: "Nektar® 2 Bottles", time: "55 minutes ago" },
    { name: "Christopher", location: "IN", product: "Nektar® 2 Bottles", time: "1 hour 15 minutes ago" },
    { name: "John", location: "NJ", product: "Nektar® 1 Bottle", time: "1 hour 36 minutes ago" },
    { name: "Alqawi", location: "NJ", product: "Nektar® 1 Bottle", time: "1 hour 58 minutes ago" },
    { name: "Silvia", location: "CA", product: "Nektar® 3 Bottles", time: "2 hours 21 minutes ago" },
    { name: "Daniel", location: "CA", product: "Nektar® 1 Bottle", time: "2 hours 45 minutes ago" },
    { name: "Albertsons", location: "IN", product: "Nektar® 1 Bottle", time: "3 hours 10 minutes ago" },
    { name: "Roger", location: "CA", product: "Nektar® 2 Bottles", time: "3 hours 36 minutes ago" },
    { name: "Curtis", location: "ON", product: "Nektar® 1 Bottle", time: "22 minutes ago" },
    { name: "Nicole", location: "CA", product: "Nektar® 1 Bottle", time: "46 minutes ago" },
    { name: "Devona", location: "MD", product: "Nektar® 1 Bottle", time: "1 hour 12 minutes ago" },
    { name: "Rony", location: "ME", product: "Nektar® 1 Bottle", time: "1 hour 39 minutes ago" },
    { name: "Otis", location: "PA", product: "Nektar® 3 Bottles", time: "2 hours 7 minutes ago" },
    { name: "Albertsons", location: "IN", product: "Nektar® 1 Bottle", time: "2 hours 36 minutes ago" },
    { name: "Jonathan", location: "CA", product: "Nektar® 1 Bottle", time: "3 hours 6 minutes ago" },
    { name: "Marcus", location: "GA", product: "Nektar® 1 Bottle", time: "3 hours 37 minutes ago" },
    { name: "Donna", location: "MD", product: "Nektar® 2 Bottles", time: "4 hours 9 minutes ago" },
    { name: "Daniel", location: "CA", product: "Nektar® 2 Bottles", time: "4 hours 42 minutes ago" },
    { name: "Silvia", location: "CA", product: "Nektar® 2 Bottles", time: "25 minutes ago" },
    { name: "Daniel", location: "CA", product: "Nektar® 1 Bottle", time: "50 minutes ago" },
    { name: "Tracey", location: "NY", product: "Nektar® 1 Bottle", time: "1 hour 16 minutes ago" },
    { name: "Roger", location: "CA", product: "Nektar® 1 Bottle", time: "1 hour 43 minutes ago" },
    { name: "Nicole", location: "CA", product: "Nektar® 1 Bottle", time: "2 hours 11 minutes ago" },
    { name: "Jonathan", location: "CA", product: "Nektar® 1 Bottle", time: "2 hours 40 minutes ago" },
    { name: "John", location: "NJ", product: "Nektar® 1 Bottle", time: "3 hours 10 minutes ago" },
    { name: "Candace", location: "CA", product: "Nektar® 2 Bottles", time: "3 hours 41 minutes ago" },
    { name: "Reginald", location: "AR", product: "Nektar® 1 Bottle", time: "4 hours 13 minutes ago" },
    { name: "Armando", location: "AR", product: "Nektar® 1 Bottle", time: "4 hours 46 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Nektar-FruitSymphony_Zoom.png?v=1733778557" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
